import React from 'react';
import LoadingContent from '~/components/LoadingContent';
import { StyledAvatar } from './styles';
export interface AvatarExamineeViewProps {
  size?: number;
  src: string;
  isLoading: boolean;
}
export const AvatarExamineeView: React.FC<AvatarExamineeViewProps> = ({
  size,
  src,
  isLoading
}: AvatarExamineeViewProps): React.ReactElement<AvatarExamineeViewProps> => <StyledAvatar alt="examinee-avatar" aria-label="examinee avatar" role="img" src={isLoading ? undefined : src} style={size ? {
  height: size,
  width: size
} : undefined} data-sentry-element="StyledAvatar" data-sentry-component="AvatarExamineeView" data-sentry-source-file="index.tsx">
    {isLoading && <LoadingContent />}
  </StyledAvatar>;
export default AvatarExamineeView;